export class ImageModel {
  public id: string = '';
  public name = '';
  public data: string = ''
  public createdAt?: Date;

  public constructor(init?:Partial<ImageModel>) {
    Object.assign(this, init);
  }
}
